import { DownloadKitButtonSelectorController } from '../controller/DownloadKitButtonSelectorController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { PackageCompanySettingsData } from '../../packagesGrid/types';

export class DownloadKitButtonSelectorWebComponent extends BaseWebComponentElement {
  private packageType: number;
  private packageId: string;
  private hasProxy: boolean;
  public controller!: DownloadKitButtonSelectorController;
  private productType: number;
  private companySettings: PackageCompanySettingsData;
  private oemKitId: number;
  private packageDetails: any;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: DownloadKitButtonSelectorController,
    });
  }

  public setPackageType(packageType: number): void {
    this.packageType = packageType;
  }

  public getPackageType(): number {
    return this.packageType;
  }

  public setPackageId(packageType: string): void {
    this.packageId = packageType;
  }

  public getPackageId(): string {
    return this.packageId;
  }

  public setHasProxy(hasProxy: boolean): void {
    this.hasProxy = hasProxy;
  }

  public getHasProxy(): boolean {
    return this.hasProxy;
  }

  public setPackageProductType(productType: number): void {
    this.productType = productType;
  }

  public getPackageProductType(): number {
    return this.productType;
  }

  public setPackageCompanySettings(companySettings: PackageCompanySettingsData): void {
    this.companySettings = companySettings;
  }

  public getPackageCompanySettings(): PackageCompanySettingsData {
    return this.companySettings;
  }

  public enableDownloadButton(enabled: boolean): void {
    this.controller.enableDownloadButton(enabled);
  }

  public getOemKitId(): number {
    return this.oemKitId;
  }

  public setOemKitId(oemKitId: number): void {
    this.oemKitId = oemKitId;
  }

  public setPackageDetails(packageDetails: any): void {
    this.packageDetails = packageDetails;
  }

  public getPackageDetails(): any {
    return this.packageDetails;
  }
}
